var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCallMade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87503 3.125H16.25C16.4158 3.125 16.5748 3.19085 16.692 3.30806C16.8092 3.42527 16.875 3.58424 16.875 3.75V13.125C16.875 13.2908 16.8092 13.4497 16.692 13.5669C16.5748 13.6842 16.4158 13.75 16.25 13.75C16.0843 13.75 15.9253 13.6842 15.8081 13.5669C15.6909 13.4497 15.625 13.2908 15.625 13.125V5.25833L4.1917 16.6917C4.07322 16.8021 3.91652 16.8622 3.7546 16.8593C3.59268 16.8565 3.43819 16.7909 3.32368 16.6764C3.20917 16.5618 3.14358 16.4074 3.14072 16.2454C3.13787 16.0835 3.19797 15.9268 3.30837 15.8083L14.7417 4.375H6.87503C6.70927 4.375 6.5503 4.30915 6.43309 4.19194C6.31588 4.07473 6.25003 3.91576 6.25003 3.75C6.25003 3.58424 6.31588 3.42527 6.43309 3.30806C6.5503 3.19085 6.70927 3.125 6.87503 3.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallMade);
export default __webpack_public_path__ + "static/media/icon_call_made.9ab3075c89a0cc916062d9aa12b124e6.svg";
export { ForwardRef as ReactComponent };